import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { getFieldData } from "../../Services/appService";
import publicIp from "react-public-ip";
import { getCurrentUser } from "../../app/store/auth";
import { useGetUserProfileLogoQuery } from "../../app/store/authApiSlice";
import { useUpdatePartPoOrderSignMutation, usePrintGeneratedPoOrdersMutation } from "../../app/store/partnerApiSlice";
import { getAlert } from "../../Services/appAlerts";

const getPartnerAddress = (data, type) => {
  const add1 = getFieldData(data, type, "Company_Address_Line1") || "";
  const add2 = getFieldData(data, type, "Company_Address_Line2") || "";
  const state = getFieldData(data, type, "Company_State") || "";
  const city = getFieldData(data, type, "Company_City") || "";
  const zip = getFieldData(data, type, "Company_Zip_Code") || "";
  return `${add1}, ${add2}, ${state}, ${city}, ${zip}`;
};

const getKeyName = (data, type) => {
  const first = getFieldData(data, type, "Key_Contact1_First_Name") || "";
  const middle = getFieldData(data, type, "Key_Contact1_Middle_Name") || "";
  const last = getFieldData(data, type, "Key_Contact1_Last_Name") || "";
  return `${first} ${middle} ${last}`.trim();
};

const PrintPurchaseOrder = (props) => {
  const { genShowHide, handleGenShowHide, candidateObj, poOrder, poAction } = props;
  const [ipAddress, setIpAddress] = useState("");
  const [esignName, setEsignName] = useState("");

  const currentUser = getCurrentUser();
  const currentUserId = currentUser?.linkUser || currentUser?.id;

  const { data: logoData } = useGetUserProfileLogoQuery(currentUserId, {
    skip: !currentUserId,
  });

  const logoPicObj = useMemo(() => {
    if (!logoData) return "/assets/Img/logo.png";
    return `${process.env.REACT_APP_API_BASEURL}/CompanyLogo/${logoData}`;
  }, [logoData]);

  const [updatePartPoOrderSign, { isLoading: saveBtnProccess, isSuccess: isSignSuccess }] =
    useUpdatePartPoOrderSignMutation();

  const [printGeneratedPoOrders, { isLoading: pdfBtnProccess, data: poPdfBlob, reset: resetPrint }] =
    usePrintGeneratedPoOrdersMutation();

  const printBodyRef = useRef();

  useEffect(() => {
    const loadIpAddress = async () => {
      const ipv4 = (await publicIp.v4()) || "";
      setIpAddress(ipv4);
    };
    loadIpAddress();
  }, []);

  const poType = poOrder?.type || "";

  const {
    strDate,
    endDate,
    poId,
    payRate,
    keyName,
    partnerName,
    partTitle,
    partContact,
    partEmail,
    partAddress,
  } = useMemo(() => {
    if (!candidateObj) {
      return {
        strDate: "",
        endDate: "",
        poId: 0,
        payRate: 0,
        keyName: "",
        partnerName: "",
        partTitle: "Key Contact",
        partContact: "",
        partEmail: "",
        partAddress: "",
      };
    }

    let sDate = "";
    let eDate = "";
    if (candidateObj.duration) {
      sDate = new Date(candidateObj.duration.startDate)?.toLocaleDateString() || "";
      eDate = new Date(candidateObj.duration.endDate)?.toLocaleDateString() || "";
    }

    let pId = 0;
    let pRate = 0;
    let kName = "";
    let pName = "";
    let pTitle = "Key Contact";
    let pContact = "";
    let pEmail = "";
    let ddName = "";

    const type = poOrder?.type;

    if (type === "subcontractor") {
      ddName = "subcontractorenrollmentform";
      pId = candidateObj.subcontractor?.fuid || 0;
      pRate = candidateObj.rates?.candidateRate || 0;
    } else if (type === "recruiter") {
      ddName = "recruiterenrollmentform";
      pId = candidateObj.recruiter?.fuid || 0;
      pRate = candidateObj.rates?.candidateRate || 0;
    }

    if (type === "recruiter" || type === "subcontractor") {
      kName = getKeyName(candidateObj.performerData, ddName);
      pName = getFieldData(candidateObj.performerData, ddName, "Company_Name") || "";
      pTitle = getFieldData(candidateObj.performerData, ddName, "Key_Contact1_Title") || "Key Contact";
      pContact = getFieldData(candidateObj.performerData, ddName, "Company_Phone") || "";
      pEmail = getFieldData(candidateObj.performerData, ddName, "Company_Email") || "";
    } else if (type === "candidate") {
      ddName = "candidateonboardingform";
      pId = candidateObj.performerid || 0;
      pRate = candidateObj.rates?.candidateRate || 0;
      const candName = `${candidateObj.performername || ""} ${candidateObj.lastName || ""}`.trim();
      pName = candName;
      kName = candName;
      pTitle = "Candidate";
      pContact = getFieldData(candidateObj.performerData, ddName, "Mobile_No") || "";
      pEmail = getFieldData(candidateObj.performerData, ddName, "Email") || "";
    }

    const pAddress = getPartnerAddress(candidateObj.performerData, ddName);

    return {
      strDate: sDate,
      endDate: eDate,
      poId: pId,
      payRate: pRate,
      keyName: kName,
      partnerName: pName,
      partTitle: pTitle,
      partContact: pContact,
      partEmail: pEmail,
      partAddress: pAddress,
    };
  }, [candidateObj, poOrder]);

  const getEmergencyFoundImg = useCallback(() => {
    const c = document.createElement("canvas");
    const img = document.getElementById("Img1");
    if (!img) return document.createElement("img");
    c.height = img.naturalHeight;
    c.width = img.naturalWidth;
    const ctx = c.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const base64String = c.toDataURL();
    const img2 = document.createElement("img");
    img2.height = img.naturalHeight;
    img2.width = img.naturalWidth;
    img2.src = base64String;
    return img2;
  }, []);

  const doSubmit = useCallback(() => {
    const logImg = getEmergencyFoundImg();
    const frmData = new FormData();
    const htmlBody =
      `<div style='text-align:center;padding-bottom:10px'>${logImg.outerHTML}</img></div>` +
      printBodyRef.current.innerHTML;

    frmData.append("html", htmlBody);
    frmData.append("poId", poOrder?.id || 0);
    frmData.append("partId", currentUser?.id || 0);
    frmData.append("signerName", esignName);
    frmData.append("signerIp", ipAddress);
    updatePartPoOrderSign(frmData);
  }, [getEmergencyFoundImg, poOrder, currentUser, esignName, ipAddress, updatePartPoOrderSign]);

  useEffect(() => {
    if (isSignSuccess) {
      getAlert("", "Signed Successfully", "success");
      handleGenShowHide("save", "");
    }
  }, [isSignSuccess, handleGenShowHide]);

  const handlePrintPdf = useCallback(() => {
    const logImg = getEmergencyFoundImg();
    const frmData = new FormData();
    const htmlBody =
      `<div style='text-align:center;padding-bottom:10px'>${logImg.outerHTML}</img></div>` +
      printBodyRef.current.innerHTML;
    frmData.append("html", htmlBody);
    printGeneratedPoOrders(frmData);
  }, [getEmergencyFoundImg, printGeneratedPoOrders]);

  useEffect(() => {
    if (poPdfBlob?.size > 0) {
      const url = window.URL.createObjectURL(poPdfBlob);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      resetPrint();
    }
  }, [poPdfBlob, resetPrint]);

  const borderCss = {
    border: "1px solid #ccc",
    borderTop: "0px",
    borderRight: "0px",
    backgroundColor: "#f0f0f0",
    width: "30%",
  };

  const borderCss1 = {
    border: "1px solid #ccc",
    borderTop: "0px",
    borderRight: "0px",
  };

  return (
    <Modal
      show={genShowHide}
      size="xl"
      centered
      onHide={() => handleGenShowHide("")}
      contentClassName="purchase-order-print-modal-content"
    >
      <style>
        {`
          .purchase-order-print-modal-content {
            border-radius: 24px;
            overflow: hidden;
            border: 1px solid rgba(226, 232, 240, 1);
            box-shadow: 0 24px 60px rgba(15, 23, 42, 0.16);
          }
        `}
      </style>
      <Modal.Header style={{ padding: "18px 22px", borderBottom: "1px solid rgba(226, 232, 240, 0.9)", background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <Modal.Title style={{ fontSize: "20px", fontWeight: 600, color: "#0f172a" }}>
            {poAction === "generate" ? "Generate Purchase Order" : "Sign Purchase Order"}
          </Modal.Title>
          <button
            type="button"
            style={{
              width: "38px",
              height: "38px",
              borderRadius: "10px",
              border: "1px solid rgba(226, 232, 240, 1)",
              background: "#ffffff",
              color: "#64748b",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "16px",
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onClick={() => handleGenShowHide("")}
            aria-label="Close purchase order print"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>
      <Modal.Body className="border">
        {poType !== "" && (
          <React.Fragment>
            <img id="Img1" src={logoPicObj} alt="Company Logo" style={{height:"133px", marginBottom:"5px", borderRadius:"10px"}}/>
            {/* <img id="Img1" src={`/assets/Img/logo.png`} /> */}
            <div id="printBody" ref={printBodyRef}>
              <table
                width="100%"
                cellPadding="3"
                cellSpacing="0"
                style={{
                  borderBottom: "1px solid #ccc",
                  paddingBottom: "5px",
                }}
              >
                <tr>
                  <td style={{ textAlign: "center" }}>
                    <p>
                      METROPOINT, Suite 1595, 600 South Highway 169,
                      Minneapolis, MN 55426
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>
                    <p>
                      Tel: 952-541-4888 Fax: 952-541-1222 Email:
                      support@ipcs.net
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>
                    <p>Web sites: www.ipcs.net www.workfinity.com</p>
                  </td>
                </tr>
              </table>
              <table width="100%" cellPadding="5">
                <tr>
                  <td>
                    <p
                      style={{
                        fontSize: "15px",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      PURCHASE ORDER # {poId}
                    </p>
                    This Purchase Order is issued pursuant to the Consulting
                    Services Agreement signed by IPCS and the{" "}
                    <span style={{ textTransform: "uppercase" }}>
                      {poType}
                    </span>
                    .
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>
                    Date: {new Date().toLocaleDateString()}
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>
                    <p>Issued To : {partnerName}</p>
                    <p>{partAddress}</p>
                    <p>
                      Phone: {partContact} Email: {partEmail}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontWeight: "bold",
                        fontSize: "15px",
                        textDecoration: "underline",
                      }}
                    >
                      Consultant Engagement Details
                    </p>
                    <p>
                      IPCS is engaging the following Consultant to work on
                      IPCS's Project
                    </p>
                  </td>
                </tr>
              </table>
              <div className="table-responsive">
                <table
                  style={{
                    border: "1px solid #ccc",
                    borderLeft: "0",
                    borderBottom: "0",
                  }}
                  width="100%"
                  cellPadding="8"
                  cellSpacing="0"
                >
                  <tr>
                    <td style={borderCss}>Candidate Name</td>
                    <td style={borderCss1}>
                      {candidateObj.performername + " " + candidateObj.lastName}
                    </td>
                  </tr>
                  <tr>
                    <td style={borderCss}>Last 4 digits of SSN</td>
                    <td style={borderCss1}>
                      {getFieldData(
                        candidateObj.performerData,
                        "candidateonboardingform",
                        "Social_Security_No"
                      )}

                    </td>
                  </tr>
                  <tr>
                    <td style={borderCss}>IPCS Client</td>
                    <td style={borderCss1}>
                      State :{" "}
                      {getFieldData(
                        candidateObj.performerData,
                        "projectengagement",
                        "State"
                      )}
                      , Agency :{" "}
                      {getFieldData(
                        candidateObj.performerData,
                        "projectengagement",
                        "AgencyName"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={borderCss}>Responsibilities/Role</td>
                    <td style={borderCss1}>
                      {getFieldData(
                        candidateObj.performerData,
                        "projectengagement",
                        "PositionTitle"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={borderCss}>Project Location</td>
                    <td style={borderCss1}>
                      {getFieldData(
                        candidateObj.performerData,
                        "projectengagement",
                        "PositionLocation"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={borderCss}>Start Date / Duration (From - To)</td>
                    <td style={borderCss1}>
                      {strDate} / {strDate} - {endDate}
                    </td>
                  </tr>
                  <tr>
                    <td style={borderCss}>Rate payable by IPCS</td>
                    <td style={borderCss1}>${payRate}/hr. (all inclusive)</td>
                  </tr>
                  <tr>
                    <td style={borderCss}>Background Check</td>
                    <td style={borderCss1}>
                      Background Check and Drug Screen to be completed I-9,
                      e-verify to be provided
                    </td>
                  </tr>
                  <tr>
                    <td style={borderCss}>Other Notes</td>
                    <td style={borderCss1}>{poOrder?.notes}</td>
                  </tr>
                </table>
              </div>
              <table width="100%" style={{ marginTop: "20px" }}>
                <tr>
                  <td>
                    All other Terms and Conditions as per the Consulting
                    Services Agreement between IPCS and the CONSULTANT will
                    remain the same.
                  </td>
                </tr>
              </table>
              <table
                width="100%"
                style={{ marginTop: "20px" }}
                cellPadding="8"
              >
                <tr>
                  <td>
                    <p>International Projects Consultancy</p>
                    <p>Services (IPCS) Inc.</p>
                  </td>
                  <td style={{ width: "10%" }}></td>
                  <td>
                    <p>{partnerName}</p>
                    <p> ({poType})</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingTop: "7px" }}>
                    <p style={{
                      fontStyle: "italic", fontWeight: "bold",
                      fontSize: "14px", marginBottom: "7px"
                    }}>{poOrder?.ipcsSignerName}</p>
                    <p>
                      {new Date(poOrder?.ipcsSignDateTime).toUTCString()}
                    </p>
                    <p>IP Address : {poOrder?.ipcsIpAddress}</p>
                  </td>
                  <td></td>
                  <td style={{ paddingTop: "7px" }}>
                    <p style={{
                      fontStyle: "italic", fontWeight: "bold",
                      fontSize: "14px", marginBottom: "7px"
                    }}>{esignName}</p>
                    <p>{new Date().toUTCString()}</p>
                    <p>IP Address : {ipAddress}</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderTop: "1px solid #ccc" }}>
                    <p>Authorized Signature</p>
                    <p>Name : Kuldeep Dhar</p>
                    <p>Title : Sr. Vice President</p>
                  </td>
                  <td></td>
                  <td style={{ borderTop: "1px solid #ccc" }}>
                    <p>Authorized Signature</p>
                    <p>Name : {keyName}</p>
                    <p>Title : {partTitle}</p>
                  </td>
                </tr>
              </table>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <label htmlFor="esignName" className="form-control-label">Sign Digitally</label>
                <textarea cols="2" rows={2}
                  id="esignName"
                  name="esignName"
                  className="form-control"
                  value={esignName}
                  placeholder="Sign Digitally"
                  onChange={({ currentTarget }) => setEsignName(currentTarget.value)}
                ></textarea>
              </div>
            </div>
          </React.Fragment>
        )}
      </Modal.Body>
      <Modal.Footer style={{ padding: "14px 22px 18px", borderTop: "1px solid rgba(226, 232, 240, 0.9)", background: "#ffffff" }}>
        {poAction === "generate" && (
          <button
            type="button"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              borderRadius: "8px",
              border: "1px solid #2563eb",
              background: "#2563eb",
              color: "#ffffff",
              padding: "9px 18px",
              fontSize: "13px",
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            disabled={saveBtnProccess}
            onClick={doSubmit}
          >
            {saveBtnProccess ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-check" aria-hidden="true"></i>}
            Generate & Send
          </button>
        )}
        <button
          type="button"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            borderRadius: "8px",
            border: "1px solid #cbd5e1",
            background: "#ffffff",
            color: "#334155",
            padding: "9px 18px",
            fontSize: "13px",
            fontWeight: 600,
            boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
          disabled={pdfBtnProccess}
          onClick={handlePrintPdf}
        >
          {pdfBtnProccess ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-print" aria-hidden="true"></i>}
          Print PDF
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default PrintPurchaseOrder;
